import { createFileRoute, redirect } from "@tanstack/react-router";
import { myStoresQuery, sellEligibilityQuery } from "@/api/queries/selling";
import { SellPageSkeleton } from "@/pages/sell/SellPage";
import { StoreSetupPage } from "@/pages/sell/StoreSetupPage";

export interface StoreSetupSearch {
  step?: "details" | "review";
}

// Store setup needs every eligibility requirement met; /sell explains (or resolves) whatever is missing.
export const Route = createFileRoute("/_app/_authed/sell/new")({
  validateSearch: (search: Record<string, unknown>): StoreSetupSearch => ({
    step: search.step === "details" || search.step === "review" ? search.step : undefined,
  }),
  beforeLoad: async ({ context }) => {
    const eligibility = await context.queryClient.fetchQuery(sellEligibilityQuery());
    if (!eligibility.eligible) throw redirect({ to: "/sell" });
  },
  loader: ({ context }) => context.queryClient.fetchQuery(myStoresQuery()),
  pendingComponent: SellPageSkeleton,
  component: StoreSetupPage,
});
